import {
  RaThemeOptions,
  defaultLightTheme,
  defaultDarkTheme,
  nanoDarkTheme,
  nanoLightTheme,
  radiantDarkTheme,
  radiantLightTheme,
  houseDarkTheme,
  houseLightTheme,
  bwLightTheme,
  bwDarkTheme,
} from 'react-admin';

import { softDarkTheme, softLightTheme } from './softTheme';
import { chiptuneTheme } from './chiptuneTheme';
import { cssVariablesTheme } from './cssVariablesTheme';

export type ThemeName =
  | 'Стандарт'
  | 'Чорне та біле'
  | 'Проста'
  | 'Мінімалістична'
  | 'Літня'
  | 'Домашня'
  | 'Програмна'
  | 'Темна';

export type Theme = {
  name: ThemeName;
  light?: RaThemeOptions;
  dark?: RaThemeOptions;
  single?: RaThemeOptions;
};

const BW_SIDEBAR_OVERRIDE = {
  styleOverrides: {
    root: {
      '& .SubMenu .MuiMenuItem-root': {
        paddingLeft: 24,
      },
      '& .RaMenu-closed .SubMenu .MuiMenuItem-root': {
        paddingLeft: 8,
      },
    },
  },
};

export const themes: Theme[] = [
  { name: 'Стандарт', light: softLightTheme, dark: softDarkTheme },
  {
    name: 'Темна',
    single: cssVariablesTheme,
  },
  { name: 'Проста', light: defaultLightTheme, dark: defaultDarkTheme },
  {
    name: 'Чорне та біле',
    light: {
      ...bwLightTheme,
      components: {
        ...bwLightTheme.components,
        RaSidebar: BW_SIDEBAR_OVERRIDE,
      },
    },
    dark: {
      ...bwDarkTheme,
      components: {
        ...bwDarkTheme.components,
        RaSidebar: BW_SIDEBAR_OVERRIDE,
      },
    },
  },
  { name: 'Мінімалістична', light: nanoLightTheme, dark: nanoDarkTheme },
  { name: 'Літня', light: radiantLightTheme, dark: radiantDarkTheme },
  { name: 'Домашня', light: houseLightTheme, dark: houseDarkTheme },
  { name: 'Програмна', single: chiptuneTheme },
];
